export default __webpack_public_path__ + "static/media/alientechnology.6b5a1ee6.jpg";